import api from './index';

const basePath = (entityId) => `/api/v1/entities/${entityId}/link_refresh_intents`;

export default {
  bankAccountRefreshIntent(entityId, bankAccountIds) {
    return api({
      method: 'post',
      url: `${basePath(entityId)}`,
      data: {
        'bank_account_ids': bankAccountIds,
      },
    });
  },
};
